module.exports = __webpack_public_path__ + "static/media/name-card-icon.7e56edfc.svg";